// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__22-TI","header":"PatientBlock_header__2swyY","label":"PatientBlock_label__3_RhU","option":"PatientBlock_option__ujSg9"};